import React, { useEffect } from "react";
import { Card } from "./style";
import { Text, CloudinaryImage } from "@website-builder/ui/shared/elements";

const PostCard = ({
	coverImage = {},
	dateOfPublishing = "",
	title = "",
	link = "",
	preload,
}) => {
	useEffect(() => {
		//  for iframes that renedered conditionaly
		if (window.lozad) {
			const observer = window.lozad(); // lazy loads elements with default selector as '.lozad'
			observer.observe();
		}
	}, []);
	return (
		<Card href={link} target="_self">
			<CloudinaryImage
				className="featured-post blog-image"
				url={coverImage?.image}
				alt={coverImage?.alt}
				quality="auto"
				lazyload
				fetchFormat="auto"
				preload={true}
				sizes={{ default: { height: 225 } }}
				dynamic
			/>
			{dateOfPublishing ? (
				<Text variant="label_M" className="date-of-publishing">
					{dateOfPublishing}
				</Text>
			) : null}
			<Text variant="headline_6">{title}</Text>
		</Card>
	);
};

export default PostCard;
